<template>
    <div class="general-status-page">
        <app-pop-up
            title="Resumen del estado del sistema"
            :closeButton="false"
            id="general-status-window"
            :options="options"
            size="extra-large"
        >
            <div class="status-body" slot="body">
                <app-entry-status></app-entry-status>
                <app-undelivered-mail></app-undelivered-mail>
                <hr />
                <app-alarm-status></app-alarm-status>
                <app-note-list></app-note-list>
            </div>
            <div class="status-buttons" slot="buttons">
                <button class="btn btn-confirm" @click="confirmStatusReview">
                    <i class="fa fa-check"></i> Confirmo que he leído las
                    anotaciones y consignas antes escritas
                </button>
            </div>
        </app-pop-up>
    </div>
</template>
<script>
import PopUp from '../../UI/Controls/PopUp/PopUp.vue'
import AlarmStatus from './AlarmStatus.vue'
import NoteList from './NoteListStatus.vue'
import EntryStatus from './EntryStatus.vue'
import UndeliveredMail from './UndeliveredMail'
import Modal from '../../UI/Controls/Modal/Modal.vue'

export default {
    components: {
        appPopUp: PopUp,
        appAlarmStatus: AlarmStatus,
        appNoteList: NoteList,
        appEntryStatus: EntryStatus,
        appUndeliveredMail: UndeliveredMail,
        appModal: Modal,
    },
    data() {
        return {
            options: {
                backdrop: 'static',
                keyboard: false,
            },
            notificationIndex: 0,
        }
    },
    methods: {
        confirmStatusReview() {
            this.$bus.$emit('general-status-window.close')
            this.$router.push({ name: 'vigilancePage' })
        },
    },
    mounted() {
        this.$bus.$emit('general-status-window.open')
    },
}
</script>
